;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Collection = APP.module('Collection');
	var Model      = APP.module('Model');

	Collection.TippingCoaches = Collection.Coaches.extend({
		api_prefix: 'tipping',
		show: function() {
			if (this.type === 'team') {
				this.setApiUrl('_join/show_joined_teams');
			}
			else {
				this.setApiUrl('_join/show_joined_users');
			}

			return this;
		}
	});

}(window, APP, Backbone, Marionette, $, _));